export default {

  settings: {
    title: 'Business Settings',

    services: {
      title: 'Services Setup',
      subtitle: 'Add service details, adjust settings, and categorize them for easy discovery.',

      services: {
        title: 'Services & Combo Services',
        subtitle: 'Create Services, define pricing, and set up No-Show Protection',
      },

      'add-ons': {
        title: 'Add-ons',
        subtitle: 'Create Add-on services that compliment your existing services',
      },

      'assign-service-type': {
        title: 'Assign Service Type',
      },
    },

    details: {
      title: 'Business Details',
      subtitle: 'Add details to establish your brand, adjust location settings, and create custom forms for customers',

      info: {
        title: 'Business name and info',
        subtitle: 'Tell customers about your business, list your contact information, and link your social media accounts',
      },
      category: {
        title: 'Business category',
        subtitle: 'Choose your business category so that we can get your profile in front of the right people',
      },
      photos: {
        title: 'Profile images',
        subtitle: 'Add your logo, upload workspace photos, and choose your cover photo',
      },
      'opening-hours': {
        title: 'Business hours',
        subtitle: 'Let your customers know when you\'re available for appointments',
      },
      'custom-forms': {
        title: 'Custom forms',
        subtitle: 'Set up Custom Forms to ensure you have the right documentation in place',
      },
      'venue-and-location': {
        title: 'Location and mobile services',
        subtitle: 'Let us know where you work and whether or not you offer services on the go',
      },
      amenities: {
        title: 'Amenities',
        subtitle: 'Inform your customers about the amenities that make your business stand out',
      },
    },

    'online-booking': {
      title: 'Online Booking',
      subtitle: 'Decide which online booking options you\'d like to make available for your clients',
    },

    'inventory': {
      title: 'Inventory',
      subtitle: 'Set up your inventory to track stock levels, manage deliveries, and log product details.',
    },

    'advanced-options': {
      title: 'Advanced Options',
      subtitle: 'Access your Booking Settings, adjust retail information, and monitor text usage',

      'booking-settings': {
        title: 'Booking Settings',
        subtitle: 'Set up auto confirmations and eliminate surprises with booking and reschedulding windows',
      },

      'pos-retail': {
        title: 'Point of Sale & Retail',
        subtitle: 'Set up your tips, assign tax rates, and create a custom message for receipts',
      },

      'document-numbering': {
        title: 'Document Numbering',
        subtitle: 'Create custom document numbers to help streamline inventory management',
      },

      'text-messages': {
        title: 'Text Messages',
        subtitle: 'Select your text messaging plan, track your usage, and enable push notifications to reduce costs',
      },

      'internal-notifications': {
        title: 'Security Warning & Notifications',
        subtitle: 'Configure your security warning to protect your business and your clients',
      },

      'fiscalization': {
        title: 'Fiscalization',
        subtitle: 'Print fiscal receipts directly from Booksy',
      },

      'turn-tracker': {
        title: 'Turn tracker',
        subtitle: 'Evenly distribute appointments and revenue across available Staff Members, avoid downtime, and quickly make adjustments.',
      },
    },

    'partner-apps': {
      title: 'Partner Apps',
      subtitle: 'Integrate with partners...',
    },

    payments: {
      title: 'Payments & Checkout',
      subtitle: 'Manage Payment methods, No-Show Protection, Checkout Settings, and view transaction history',

      'payouts-banner': {
        title: 'Try No-Show Protection to safeguard your money and prevent unreliable clients from wasting your time.',
        description: 'Just remember to add your bank account or card information to receive payouts. You can add this now via the "Add payout details" button.',
        button: 'Add payout details',
      },

      'mobile-payments': {
        title: 'Mobile Payments',
        subtitle: 'Offer clients contactless, in-app payments to streamline the checkout process.',
        'subtitle-no-kyc': 'Offer clients contactless, in-app payments to streamline the checkout process. Verify your account and set up Mobile Payments.',
      },

      'your-account': {
        title: 'Account Verification',
        subtitle: 'Upload the necessary information to verify your account and start collecting payouts',
        'account-details': {
          title: 'Account Details',
        },
        'payout-settings': {
          title: 'Payout Settings',
        },
      },
      'booksy-card-reader': {
        title: 'Booksy Card Reader',
      },
      'checkout-settings': {
        title: 'Checkout Settings',
        subtitle: 'Choose payment methods you\'ll accept, set tip rates, manage tax settings, enable cash registers, and customize your receipts',
      },
      'tap-to-pay': {
        title: 'Tap to Pay',
        subtitle: 'Accept contactless payments from physical cards and digital wallets directly on your mobile device – no extra hardware required.',
      },
      'booksy-gift-cards': {
        'title': 'Booksy Gift Cards',
        'subtitle': 'Start accepting Booksy Gift Cards to attract new clients, increase revenue and keep your calendar full',
      },
      'booksy-pay': {
        title: 'Booksy Pay',
        subtitle: 'Let clients pay for appointments in the app with cards, BLIK, Apple Pay, Google Pay, and Klarna.',
      },
    },

    subscription: {
      title: 'Subscription & Billing',
      subtitle: 'Billing Details, Subscription, Payment Method',

      'your-subscription': {
        title: 'Your Subscription',
        subtitle: "Manage your Booksy subscription and see what's included with your plan",
        'title-trial': 'Your subscription',
      },

      'billing-details': {
        title: 'Billing Details',
        subtitle: 'Review charges from the current billing cycle and access past statements',
        'your-next-payment': {
          title: 'Your Billing',
        },
        'billing-history': {
          title: 'Billing History',
        },
        'invoice-details': {
          title: 'Business Details For Invoicing',
        },
      },

      'payment-method': {
        title: 'Payment Method',
        subtitle: 'Add or modify the payment method you would like to use for your Booksy subscription',
        add: {
          title: 'Payment Method',
        },
        change: {
          title: 'Payment Method Change',
        },
      },

      'terms-and-conditions': {
        'title': 'Booksy Price List',
      },
    },

    personal: {
      title: 'Personal Settings',
      subtitle: 'Modify your language and switch business profiles (if applicable)',

      notifications: {
        title: 'Notifications',
        subtitle: 'Adjust your notification settings to ensure you don\'t miss any important details',
      },

      'select-business': {
        title: 'Select Business',
        subtitle: 'Select which of your Booksy businesses you would currently like to manage',
      },

      language: {
        title: 'Language',
        subtitle: 'Select your preferred display language from our list of supported languages',
      },

      logout: {
        title: 'Logout',
        subtitle: 'Log out of your current Booksy session on this device',
      },

      performance: {
        title: 'Performance',
        subtitle: 'Application performance',
      },

      'sign-in-methods': {
        title: 'Sign In Methods',
        subtitle: 'Connect your Booksy account with Google or Facebook and log in even faster',
      },
    },

    'no-show': {
      title: 'No-Show Protection',
      subtitle: 'Set up Deposits and Cancellation Fees to protect yourself against No-Shows.',
      'subtitle-no-kyc': 'Set up Deposits and Cancellation Fees to protect yourself against No-Shows. Verify your account and set up No-show Protection.',
    },

    'booksy-app': {
      title: 'Booksy App',
      subtitle: 'Access to Booksy\'s Terms & Conditions and Privacy Policy',
      version: 'System version: {name} {version}',
      subscription: {
        title: 'Subscription & Billing',
        subtitle: 'Manage your Booksy subscription, view statements, and your payment method',
      },
      privacy: {
        title: 'Your Data Protection',
      },
      gdpr: {
        title: 'Privacy Rights (GDPR)',
      },
      licenses: {
        title: 'Application Licenses',
      },
      'privacy-policy-terms-of-use': {
        'title': 'Terms of Use',
      },
      'delete-your-account': {
        'title': 'Delete Your Account',
      },
      'privacy-policy': {
        'title': 'Privacy policy',
      },
      'information-obligation': {
        'title': 'Information obligation',
      },
    },

    'health-safety-rules': {
      title: 'Health and safety rules',
      subtitle: 'Establish rules to create a safe environment for you and your customers',
    },

    'privacy-policy-terms': {
      title: 'Booksy App',
      subtitle: 'Terms & Conditions, Privacy Policy',
    },

    'account-verification': {
      title: 'Account Verification',
      subtitle: 'Upload the necessary information to verify your account and start collecting payouts',
    },

    'loyalty-program': {
      title: 'Loyalty Cards Program',
      subtitle: 'Create stamp cards for clients and track their rewards',
      program: {
        title: 'Loyalty Program',
        subtitle: 'Create Loyalty Programs, choose the settings that work best for your business, and set the reward.',
      },
      cards: {
        title: 'Loyalty Cards',
        subtitle: 'Manage Loyalty Cards and track client participation.',
      },
    },
  },

  gifts: {
    'gift-cards': {
      title: 'Gift Cards',
      subtitle: 'Allow your customers to buy gift cards and share your talent with their friends',
    },

    memberships: {
      title: 'Memberships',
      subtitle: 'Use memberships to offer unlimited visits for specific services',
    },

    packages: {
      title: 'Packages',
      subtitle: 'Encourage repeat visits or combine multiple services into a single experience',
    },
  },

  'promotion': {
    title: 'Marketing',
    'message-your-clients': {
      title: 'Text and Email Marketing ',
      subtitle: 'Stay top of mind for your clients',
    },
    'text-email-marketing': {
      title: 'Text & Email Marketing',
      subtitle: 'Automate campaigns or send one-time messages',
    },
    boost: {
      title: 'Boost',
      subtitle: 'Let Booksy help you get discovered',
    },
    'boost-promoted': {
      title: 'Get Promoted',
      subtitle: 'Let Booksy help you get discovered',
    },
    'boost-share': {
      title: 'Share Your Link',
      subtitle: 'Link to your Booksy profile so we know which bookings you deserve all the credit for.',
      'share-link': 'Share your link',
      'share-unique-link': 'Share your unique booking link with clients so we know which bookings are not from Boost.',
    },
    'boost-help': {
      title: 'Get Help',
      subtitle: 'Read more about Boost toolkit.',
      'subtitle-with-terms': 'Read more about Boost toolkit. See Boost Terms & Conditions.',
      'how-it-work': {
        'title': 'How does it work?',
      },
      'identifying-new-clients': {
        'title': 'Identifying New Clients',
      },
      'claim-clients': {
        'title': 'Claim Your Client',
      },
      'pricing': {
        'title': 'Boost Pricing',
      },
      'prevent-accidental-charges': {
        'title': 'Prevent Accidental Charges',
      },
      'terms-and-conditions': {
        title: 'Boost Terms & Conditions',
      },
    },
    invite: {
      title: 'Import & Invite Clients',
      subtitle: 'Invite your clients to book online 24/7',
    },
    'special-offers': {
      title: 'Promotions',
      subtitle: 'Use promotional tools to engage your clients',
    },
    'flash-sale': {
      title: 'Flash Sale',
      subtitle: 'Promote your services and encourage more bookings',
    },
    'happy-hours': {
      title: 'Happy Hours',
      subtitle: 'Offer discounts to help fill your calendar',
    },
    'premium-hours': {
      title: 'Premium Hours',
      subtitle: 'Charge more for high-demand times and non-standard workdays',
    },
    'last-minute': {
      title: 'Last Minute Discount',
      subtitle: 'Give your clients a break if they book last minute',
    },
    'social-media': {
      title: 'Social Media Marketing',
      subtitle: 'Show off your business on social media',
    },
    'social-media-marketing': {
      title: 'Social Media Marketing',
      subtitle: 'Create and share custom posts and graphics',
    },
    'visibility-promotion': {
      title: 'Profile promotion',
      subtitle: 'Put your profile in the spotlight to reach potential clients.',
    },
  },

}
